// extracted by mini-css-extract-plugin
export default {"container":"VouchersScreen_container__b05En","content":"VouchersScreen_content__kINiw","header":"VouchersScreen_header__Z4J1p","backButton":"VouchersScreen_backButton__3U4J9"};